import React from 'react'
import style from './Overlay.module.scss'
import { OverlayProps } from './types'

const Overlay: React.FC<OverlayProps> = ({ children, name = '', title = '', isDisabled = true, reducedHeight, inSidebar = false }) =>
  <div className={style['overlay__container']}>
    {children}
    <div
      className={`${style[`overlay`]} ${isDisabled ? style[`overlay--hide`] : ''} ${reducedHeight ? style[`overlay--reduced-height`] : ''}`}
      data-bdd={`${inSidebar ? 'talks-screen-overlay-sidebar' : 'talks-screen-overlay'}`}
    >
      <div
        className={style[`overlay__text-box`]}
      >
        <span
          className={`${style[`overlay__text`]} ${style['overlay__user-name']}`}
          data-bdd={`${inSidebar ? 'talks-screen-overlay-name-sidebar' : 'talks-screen-overlay-name'}`}
        >
          {name}
        </span>
        {name !== '' && title !== '' && <>&nbsp;</>}
        <span
          className={`${style[`overlay__text`]} ${style['overlay__user-title']}`}
          data-bdd={`${inSidebar ? 'talks-screen-overlay-title-sidebar' : 'talks-screen-overlay-title'}`}
        >
          {title}
        </span>
      </div>
    </div>
  </div>

export default Overlay
